<p-dialog [(visible)]="visible"
    [header]="titulo"
    [breakpoints]="{'960px': '90vw', '640px': '100vw'}"
    [style]="{width: '90vw', maxWidth: '1200px'}"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="leitura-estacao-dialog">

    <div *ngIf="loading" class="leitura-loading-state">
        <p-progressSpinner [style]="{width: '56px', height: '56px'}" strokeWidth="6"
            fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
        <span>Carregando leituras...</span>
    </div>

    <div *ngIf="!loading && dadosNaoEncontrados" class="leitura-empty-state">
        <p-message severity="warn" text="Nenhum registro foi encontrado para o dia selecionado."></p-message>
    </div>

    <app-variavel *ngIf="!loading && dadosVariavel.length > 0"
        [value]="dadosVariavel"
        [columns]="columnsVariavel"
        [descricao_estacao]="descricaoEstacao"
        [estacaoColetas]="estacaoColetas"
        [exibirMarcacoesEvento]="true">
    </app-variavel>

    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Fechar" icon="pi pi-times"
            class="p-button-text" (click)="visible = false"></button>
    </ng-template>
</p-dialog>
